var React = require('react');

function ChevronRightBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.80322 9.00002L6.93746 6.13427C6.62696 5.82377 6.62696 5.31977 6.93746 5.00927C7.24796 4.69877 7.75196 4.69877 8.06246 5.00927L11.523 8.46977C11.8162 8.76302 11.8162 9.23777 11.523 9.53027L8.06246 12.9908C7.75196 13.3013 7.24796 13.3013 6.93746 12.9908C6.62696 12.6803 6.62696 12.1763 6.93746 11.8658L9.80322 9.00002Z","fill":"#2D87F3"}));
}

ChevronRightBlue.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = ChevronRightBlue;

ChevronRightBlue.default = ChevronRightBlue;
